var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.3 18.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-H2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2350519539584",
    "data-name": 2350519539584
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.64,8.59C1.58,8.9.72,10.56.3,12.44A13.48,13.48,0,0,0,0,15.73a2.86,2.86,0,0,0,1.25,2.39,5,5,0,0,0,3.07.53h7.23a16,16,0,0,0,3.49-.15c2.29-.68,2.23-3.08,1.95-5-.25-1.72-.85-3.88-2.59-4.64-2.42-1.06-2.08,1-5.32,1.34A5.78,5.78,0,0,1,5,9c-.62-.39-.59-.47-1.37-.36Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0A4.36,4.36,0,0,0,5,1.67a4.68,4.68,0,0,0,.61,6.6,4.46,4.46,0,0,0,3.53,1,4.64,4.64,0,0,0,4.11-5.18A4.62,4.62,0,0,0,8,0Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.32,17.9l-3.55-2.61c-.63-.47-.38-1-.38-1.74l3.93,2.91,3.93-2.91c0,.92.29,1.23-.56,1.86L22.32,17.9Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.76 2.03 22.87 2.03 22.87 16.89 21.76 16.89 21.76 2.03",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.32.59,18.77,3.2c-.63.47-.38,1-.38,1.74L22.32,2l3.93,2.91c0-.92.29-1.23-.56-1.86L22.32.59Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2);
export default __webpack_public_path__ + "static/media/H2.bd85f90ab048bea3b73a57e3083caee6.svg";
export { ForwardRef as ReactComponent };